import { useConnection } from "@solana/wallet-adapter-react";
import type { NFTCollateralPositionMap } from "@stepfinance/lending";
import { SharkyPositionFetcher } from "@stepfinance/lending";
import { useEffect, useMemo } from "react";

import { useMarkets } from "../../contexts/market";
import { useRefreshContext } from "../../contexts/refresh";
import { getTokenByMint } from "../../utils/tokenInfo";
import { fetchAndCacheMetaplexMetadata } from "../../utils/utils";
import { useSharkyQuery } from "../queries/lending/useSharkyQuery";
import { useConnectedWallet } from "../wallet";

const defaultNFTCollateralPositionMap: NFTCollateralPositionMap = {
  nftCollateral: [],
  collections: [],
  totalValueUSD: {
    net: null,
    supplied: null,
    borrowed: null,
  },
};

export const useSharkyLending = () => {
  const { connection } = useConnection();
  const wallet = useConnectedWallet();
  const { refreshID } = useRefreshContext();
  const { marketsInitialised, priceInUSD } = useMarkets();

  const fetcher = useMemo(() => {
    if (!wallet) {
      return undefined;
    }
    return new SharkyPositionFetcher({
      wallet,
      connection,
      fetchAndCacheMetaplexMetadata,
      getTokenByMint,
    });
  }, [connection, wallet]);

  const { data, refetch } = useSharkyQuery(priceInUSD, marketsInitialised, fetcher);

  useEffect(() => {
    refetch().catch(console.error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshID]);

  return { collateral: {}, yieldFarms: {}, nftLending: data ?? defaultNFTCollateralPositionMap };
};
